import React from 'react';

/**
 * ProfileDropdown used in Race-Ready mode headers (MyRaces, MyRaceDetail).
 * Shows avatar + "Profile" label, and a dropdown with View Profile, Race-Ready toggle,
 * Settings, and Logout.
 */
const ProfileDropdown = ({
  currentUserId,
  userName,
  raceReadyMode,
  onToggleRaceReady,
  onLogout,
  showProfileDropdown,
  setShowProfileDropdown
}) => (
  <div style={{ position: 'relative' }}>
    <div
      onClick={() => setShowProfileDropdown(!showProfileDropdown)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        cursor: 'pointer',
        padding: '0.5rem 1rem',
        borderRadius: '25px',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(139, 156, 179, 0.2)'
      }}
    >
      <div style={{
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        background: '#FF8A3D',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.8rem',
        fontWeight: 600,
        color: '#0B0B10'
      }}>
        {userName ? userName.charAt(0).toUpperCase() : (currentUserId ? currentUserId.substring(0, 2).toUpperCase() : '?')}
      </div>
      <span style={{ color: '#FFFFFF', fontSize: '0.9rem' }}>Profile</span>
      <span style={{
        color: '#8b9cb3',
        fontSize: '0.75rem',
        transform: showProfileDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s ease'
      }}>▼</span>
    </div>

    {showProfileDropdown && (
      <div style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        marginTop: '0.5rem',
        background: '#16161D',
        border: '1px solid rgba(255, 138, 61, 0.2)',
        borderRadius: '12px',
        padding: '0.5rem',
        minWidth: '200px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
        zIndex: 100
      }}>
        <button style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          color: '#FFFFFF',
          background: 'transparent',
          border: 'none',
          borderRadius: '8px',
          fontSize: '0.9rem',
          cursor: 'pointer',
          width: '100%',
          textAlign: 'left'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <span>👤</span> View Profile
        </button>

        {/* Race-Ready Mode Toggle */}
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (onToggleRaceReady) onToggleRaceReady();
            setShowProfileDropdown(false);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0.75rem 1rem',
            borderRadius: '8px',
            cursor: 'pointer',
            background: raceReadyMode ? 'rgba(255, 138, 61, 0.15)' : 'transparent'
          }}
          onMouseEnter={(e) => {
            if (!raceReadyMode) e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
          }}
          onMouseLeave={(e) => {
            if (!raceReadyMode) e.currentTarget.style.background = 'transparent';
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <span>🏁</span>
            <span style={{ color: raceReadyMode ? '#FF8A3D' : '#FFFFFF', fontSize: '0.9rem' }}>
              Race-Ready Mode
            </span>
          </div>
          {/* Toggle Switch */}
          <div style={{
            width: '40px',
            height: '22px',
            borderRadius: '11px',
            background: raceReadyMode ? '#FF8A3D' : 'rgba(139, 156, 179, 0.3)',
            position: 'relative',
            transition: 'background 0.2s ease'
          }}>
            <div style={{
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              background: '#fff',
              position: 'absolute',
              top: '2px',
              left: raceReadyMode ? '20px' : '2px',
              transition: 'left 0.2s ease',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
            }} />
          </div>
        </div>

        <button style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          color: '#FFFFFF',
          background: 'transparent',
          border: 'none',
          borderRadius: '8px',
          fontSize: '0.9rem',
          cursor: 'pointer',
          width: '100%',
          textAlign: 'left'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <span>⚙️</span> Settings
        </button>
        <div style={{
          height: '1px',
          background: 'rgba(139, 156, 179, 0.2)',
          margin: '0.5rem 0'
        }} />
        <button
          onClick={onLogout}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            padding: '0.75rem 1rem',
            color: '#ff6b6b',
            background: 'transparent',
            border: 'none',
            borderRadius: '8px',
            fontSize: '0.9rem',
            cursor: 'pointer',
            width: '100%',
            textAlign: 'left'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,107,107,0.1)'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <span>🚪</span> Logout
        </button>
      </div>
    )}
  </div>
);

export default ProfileDropdown;
